/* eslint-disable */
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import { isEmptyString, getStorge, saveStorge, removeStorge, format, checkUrl, getFromForLog } from './q_business'
const hysdk = window.hysdk

let Sniff = (hysdk && hysdk.sniff) || {}

const qunarhytiveReg = '(^|\\s)(qunar[^\\/]+)\\/([\\d\\.]+)'
let space;
[Sniff.qunar, space, Sniff.scheme, Sniff.appVersion] = navigator.userAgent.toLowerCase().match(qunarhytiveReg) || [];
Sniff.qunar = !!Sniff.qunar

//全面屏
let notchHeight = 0
let isImmersion = false
let safeAreaBottomHeight = 0
try {
  const { immersiveInfo } = JSON.parse(hysdk.systemInfo)
  notchHeight = immersiveInfo.immersiveOffset
  isImmersion = immersiveInfo.immersive
  safeAreaBottomHeight = immersiveInfo.safeAreaBottomHeight
} catch (error) {}

Sniff.isImmersion = isImmersion
Sniff.immersiveOffset = notchHeight
Sniff.safeAreaBottomHeight = safeAreaBottomHeight

//adr6.0以上支持设置状态栏颜色
const statusEnable = !Sniff.ios && Sniff.osVersionN >= 6.0
Sniff.statusStyleEnable = statusEnable
if (isImmersion && Sniff.qunar && statusEnable) {
  hysdk.ready((env) => {
    hysdk.app.setStatusBarStyle({
      color: 'dark'
    })
  })
}

const statusBarHeight = !Sniff.ios ? notchHeight : Sniff.iphoneX ? 44 : 20
Sniff.statusBarH = Sniff.qunar ? statusBarHeight : 0
Sniff.safeAreaX = Sniff.qunar && Sniff.iphoneX ? 34 : 0

const projTag = 'bnb_tujia'
Sniff[projTag] = {}
try {
  Sniff[projTag] = getStorge(projTag) || {}
} catch (e) {
  console.log(e)
}

let QN241 = decodeURIComponent(Cookies.get('QN241') || ''),
  QN270 = decodeURIComponent(Cookies.get('QN270') || ''),
  appInfo = {}

if (QN270 && QN270.split(',').length === 5) {
  let arr = QN270.split(',')

  appInfo.uid = arr[0]
  appInfo.vid = arr[1]
  appInfo.cid = arr[2]
  appInfo.gid = arr[3]
  appInfo.pid = arr[4]
} else if (QN241) {
  QN241 = JSON.parse(QN241)
  appInfo.vid = QN241.vid
  appInfo.pid = QN241.pid
  appInfo.uid = QN241.uid
  appInfo.cid = QN241.cid
  appInfo.gid = QN241.gid
}
//先从cookie里取id信息填充 防止getDeviceInfo异步返回慢
if (JSON.stringify(appInfo) !== '{}') {
  Sniff[projTag] = {
    ...Sniff[projTag],
    ...appInfo
  }
}

// 判断是否是小程序环境
if (Sniff.qunar) {
  Sniff.miniprogram = false;
} else {
  Sniff.miniprogram = window.__wxjs_environment === 'miniprogram' || isWXMiniprogram();
  setTimeout(_ =>{
      window.wx && wx.miniProgram.getEnv(function (res) {
          Sniff.miniprogram = res.miniprogram;
      });
  }, 1000);
}

const idsForTouch = (prefix) => {
  const { appName, appVersion, language, platform, userAgent, vendor } = navigator
  const { height, width, pixelDepth, colorDepth } = screen
  //采集一些设备、环境相关信息当做设备指纹
  const id = `${appName}-${appVersion}-${language}-${platform}-${userAgent}-${vendor}-${height}-${width}-${pixelDepth}-${colorDepth}`

  const randomStr = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  //随机字符串
  const rs = `${randomStr()}-${randomStr()}${randomStr()}-${randomStr()}`
  return CryptoJS.MD5(`${prefix}_${id}-${rs}-${new Date().getTime()}`).toString()
}

hysdk &&
  hysdk.ready((env) => {
    if (env === 'hy') {
      hysdk.getDeviceInfo({
        hybridId: 'h_tujia_single_hy',
        success: function(res) {
          Sniff[projTag] = res || {}
          try {
            saveStorge(projTag, Sniff[projTag])
          } catch (e) {}
        }
      })

      // 获取网络类型2G，3G，2G/3G，4G，wifi，unknown
      hysdk.getNetworkType({
        success: function(res) {
          Sniff.networkType = res.networkType
        },
        fail: function() {
          Sniff.networkType = 'unknown'
        }
      })
    } else {
      const idsKey = 'bnb_tujia_touch_ids'
      let ids = getStorge(idsKey)
      if (!ids) {
        ids = {
          uid: idsForTouch('uid'),
          gid: idsForTouch('gid')
        }
        saveStorge(idsKey, ids)
      }
      Sniff[projTag] = {
        ...Sniff[projTag],
        ...ids
      }
    }
  })

const U_INFO = 'uinfo_bnb_c'
Sniff.uinfo = {}

const initUinfo = () => new Promise((resolve) => {
  // 先取cookie中un 已登陆则校验与session中info是否一致 未登录则清空
  let cookieUn = decodeURIComponent(Cookies.get('_q') || '').replace('""', '')
  if (!isEmptyString(cookieUn) && (!cookieUn.startsWith('G.') || !cookieUn.startsWith('G:'))) {
    // 已登陆 (G开头为游客登录 视为未登录)
    cookieUn = cookieUn.slice(2)
    Sniff.uinfo.username = cookieUn
    const preUi = getStorge(U_INFO)
    // session中没有uinfo或者用户名与从cookie获取的不一致则重新获取 没有用户uid也要重新获取
    if (!preUi || preUi.username !== cookieUn || !preUi.uid) {
      hysdk && hysdk.ready((env) => {
        hysdk.checkLogin({
          success: (logindata) => {
            if (logindata.state === 2) {
              hysdk.getUserInfo({
                success: (res) => {
                  if (res.data) {
                    const { username = '', uid = '', nickname = '' } = res.data
                    Sniff.uinfo = {
                      username,
                      uid,
                      nickname
                    }
                    saveStorge(U_INFO, Sniff.uinfo)
                    // 埋点同步uid
                    window._fas?.setUserId(uid)
                    Sniff.isLogin = true
                    resolve()
                  }
                }
              })
            } else {
              removeStorge(U_INFO)
              Sniff.isLogin = false
              resolve()
            }
          }
        })
      })
    } else {
      Sniff.uinfo = preUi
      // 埋点同步uid
      window._fas?.setUserId(preUi.uid)
      Sniff.isLogin = true
      resolve()
    }
  } else {
    //未登录清空session中uinfo
    removeStorge(U_INFO)
    Sniff.isLogin = false
    resolve()
  }
})
initUinfo()

Sniff.updateUinfo = (payload) => {
  if (Sniff.miniprogram) {
    const { username = '', uid = '' } = payload
    Sniff.uinfo.username = username
    Sniff.uinfo.uid = uid
    saveStorge(U_INFO, Sniff.uinfo)
    // 埋点同步uid
    window._fas?.setUserId(uid)
    return
  }
  hysdk.getUserInfo({
    success: (res) => {
      if (res.data) {
        const { username = '', uid = '', nickname = '' } = res.data
        Sniff.uinfo = {
          username,
          uid,
          nickname
        }
        Sniff.isLogin = true
        saveStorge(U_INFO, Sniff.uinfo)
        // 埋点同步uid
        window._fas?.setUserId(uid)
      }
    }
  })
}

Sniff.getCookieUn = () => {
  try {
    const _q = decodeURIComponent(Cookies.get('_q') || '')
    return _q
  } catch (error) {
    return ''
  }
}


// 兼容小程序环境
function isWXMiniprogram() {
  const href = window.location.href || '';
  const pattern = href.match(/channel=([\w]+)(&|$)/);
  const channel = pattern && pattern[1] || '';
  const ua = window.navigator.userAgent.toLowerCase();
  const isWX = ua.indexOf('micromessenger') != -1;
  return isWX && channel === 'miniprogram';
}


const serialize = (receiver, obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]
      const t = typeof value
      const v = t === 'string' || t === 'number' ? value : JSON.stringify(value)
      receiver.add(key, v)
    }
  }
}

// const QShare = (opts) => {
//   const fromForLog = getFromForLog()
//   const { title, link, desc, imgUrl, timeLineImg, wechatImg, fId } = opts
//   if (Sniff.miniprogram) {
//     wx && wx.miniProgram.navigateTo({
//       url: `/pages/bnb/share/index?sharePath=${encodeURIComponent('/home/pages/index?navigateTo=' + encodeURIComponent(`/bnb/pages/home/index?webview_url=${encodeURIComponent(checkUrl(window.location.href))}`) + `&fromForLog=${fromForLog}`)}&title=${title}&wechatImg=${wechatImg}&timeLineImg=${timeLineImg}&desc=${desc}&fId=${fId}`
//     })
//     return
//   }
//   hysdk &&
//     hysdk.ready(res => {
//       hysdk.share.share({
//         shareInfos:[{
//           shareType: "WechatFriends",
//           imageUrl: wechatImg || imgUrl,
//           title: title,
//           text: desc,
//           miniProgramPath: `/pages/alonePlatform/webView/index?url=${encodeURIComponent(link)}`,
//           miniProgramUserName: 'gh_7ffb9c5d761f',
//           shareHdImageURL: imgUrl,
//           miniProgramType: 'release',
//           imgCompress: 'original'
//         }, {
//           shareType: "Default", //表示其他未指定的平台，都适用该分享内容
//           imageUrl: imgUrl,
//           title: title,
//           text: desc,
//           linkUrl: link
//         }],
//         options:{},
//         success: function(e) {},
//         fail: function(e) {}
//     });
//   })
// }

Sniff.isRN = false;
if(Sniff.qunar) {
  if (Sniff.ios) {
    if (Sniff.appVersion >= 80011225)Sniff.isRN = true
  } else {
    if (Sniff.appVersion >= 60001349)Sniff.isRN = true
  }
}

Sniff.isHarmonyWithoutAdr = false;
const regex = /^5000\d{4}$/

if ((Sniff.appVersion >= 60001582 && Sniff.appVersion <= 60001589) || regex.test(`${Sniff.appVersion}`)) {
  Sniff.isHarmonyWithoutAdr = true
}

const QConfig = () => {
  if (Sniff.qunar) {
    hysdk &&
    hysdk.ready((res) => {
      hysdk.hideOptionMenu({})
    })
  }
}
let time = ''
const syncTime = (timestamp) => {
  if (!timestamp) {
    return
  }
  time = timestamp
}

const getLogDate = () => {
  if (!time) {
    return format('yyyy-MM-dd hh:mm:ss:S', new Date())
  }
  const hms = format('hh:mm:ss:S', new Date())
  const initTimestamp = `${time} ${hms}`
  return initTimestamp
}
export { Sniff, QConfig, syncTime, getLogDate, initUinfo }
